import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {InfoBannerComponent} from './info-banner.component';

@NgModule({
  imports: [CommonModule, MatIconModule],
  declarations: [InfoBannerComponent],
  exports: [InfoBannerComponent]
})
export class InfoBannerModule {}
